import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadPaperworkList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    if (options.organisationId) {
      const result = await axios.get(
        `${baseUrl}/customer/mob/organisations/${
          options.organisationId
        }/paperwork${params ? `?${params}` : ''}`,
      );
      return result.data;
    }
  },
};
